import axios from "axios";

let base_url = "https://api.ihartglobal.org";

// Login- Signup Apis

export const loginUser = (user) => {
  return axios.post(`${base_url}/api/user/login`, user);
};

// Clients Apis

export const getAllClients = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;

  return axios.get(`${base_url}/api/client/get-all`, { params });
};

export const postClient = (data) => {
  return axios.post(`${base_url}/api/client/post`, data);
};

export const deleteClient = (data) => {
  return axios.post(`${base_url}/api/client/delete`, data);
};

// Authors apis

export const getAllAuthors = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;
  return axios.get(`${base_url}/api/author/get-all`, { params });
};

export const postAuthor = (data) => {
  return axios.post(`${base_url}/api/author/post`, data);
};

export const deleteAuthor = (data) => {
  return axios.post(`${base_url}/api/author/delete`, data);
};

// News Events Catageory

export const getAllCatageory = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;

  return axios.get(`${base_url}/api/category/get-all`, { params });
};

export const postCatageory = (data) => {
  return axios.post(`${base_url}/api/category/post`, data);
};

export const deleteCatageory = (data) => {
  return axios.post(`${base_url}/api/category/delete`, data);
};

// Publications apis

export const getAllPublications = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;

  return axios.get(`${base_url}/api/publication/get-all`, { params });
};

export const postPublication = (data) => {
  return axios.post(`${base_url}/api/publication/post`, data);
};

export const deletePublication = (data) => {
  return axios.post(`${base_url}/api/publication/delete`, data);
};

// News Events apis

export const getAllNE = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;

  return axios.get(`${base_url}/api/newsevent/get-all`, { params });
};

export const postNE = (data) => {
  return axios.post(`${base_url}/api/newsevent/post`, data);
};

export const deleteNE = (data) => {
  return axios.post(`${base_url}/api/newsevent/delete`, data);
};

// Contact Us api

export const getAllContacts = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;
  return axios.get(`${base_url}/api/contactus/get-all`, { params });
};
export const deleteContact = (data) => {
  return axios.post(`${base_url}/api/contactus/delete`, data);
};


// Recent News and noti api

export const getAllRecentNewsNoti = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;
  return axios.get(`${base_url}/api/recent-news-notification/get-all`, { params });
};
export const postRecentNewsNoti = (data) => {
  return axios.post(`${base_url}/api/recent-news-notification/post`, data);
};
export const deleteRecentNewsNoti = (data) => {
  return axios.post(`${base_url}/api/recent-news-notification/delete`, data);
};

//Team apis
export const getAllTeam = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;
  return axios.get(`${base_url}/api/team/get-all`, { params });
};
export const postTeam = (data) => {
  return axios.post(`${base_url}/api/team/post`, data);
};
export const deleteTeam = (data) => {
  return axios.post(`${base_url}/api/team/delete`, data);
};

//About-Us apis
export const getAllAboutContent = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;
  return axios.get(`${base_url}/api/about-us/get-all`, { params });
};
export const postAboutContent = (data) => {
  return axios.post(`${base_url}/api/about-us/post`, data);
};
export const deleteAboutContent = (data) => {
  return axios.post(`${base_url}/api/about-us/delete`, data);
};

//Services apis
export const getAllServices = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;
  return axios.get(`${base_url}/api/service/get-all`, { params });
};
export const postServices = (data) => {
  return axios.post(`${base_url}/api/service/post`, data);
};
export const deleteServices = (data) => {
  return axios.post(`${base_url}/api/service/delete`, data);
};

//home apis
export const getAllHomeData = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;
  return axios.get(`${base_url}/api/home_statement/get-all`, { params });
};
export const postHomeData = (data) => {
  return axios.post(`${base_url}/api/home_statement/post`, data);
};
export const deleteHomeData = (data) => {
  return axios.post(`${base_url}/api/home_statement/delete`, data);
};

//solution apis
export const getAllSolutionData = (limit, page, searchText) => {
  let params = {};
  if (limit) params.limit = limit;
  if (page) params.page = page;
  if (searchText)
    params.search = typeof searchText != "undefined" ? searchText : null;
  return axios.get(`${base_url}/api/solution/get-all`, { params });
};
export const postSolutionData = (data) => {
  return axios.post(`${base_url}/api/solution/post`, data);
};
export const deleteSolutionData = (data) => {
  return axios.post(`${base_url}/api/solution/delete`, data);
};

